import { render, staticRenderFns } from "./loader-item.vue?vue&type=template&id=52e11c1e"
import script from "./loader-item.vue?vue&type=script&lang=js"
export * from "./loader-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports